import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import { ROUTES } from "../Routes";

const HomePage = () => {

  return (
    <div className="home blog wp-theme-ppc2">
      <Navigation />
      <main id="main">
        <div className="container">

          <div className="broadcast">
            <section className="hero" aria-label="Hero">
              <div className="hero-inner">
                <span className="mansion-windows" aria-hidden="true"></span>
                <span className="mansion-arch" aria-hidden="true"></span>
                <span className="hero-web hero-web--left" aria-hidden="true"></span>
                <span className="hero-web hero-web--right" aria-hidden="true"></span>

                <div className="kicker">ELDER HOUSE • VIRTUAL-ONLY CHAMBERS</div>

                <div className="hero-frame">
                  <h1 className="hero-title">
                    <span className="hero-title__name">Velar Games</span>
                  </h1>
                  <p className="hero-disclaimer age-notice">18+ ONLY • VIRTUAL CREDITS • NO CASH VALUE</p>
                </div>

                <p className="hero-lead">
                  Step into the Elder House 🕯 where green light clings to the beams and every ritual is pure
                  entertainment.
                  All play uses virtual Credits only — no deposits, no withdrawals, no real-money value. The
                  only thing
                  at stake is your legend inside the house.
                </p>

                <div className="hero-actions">
                  <Link to={ROUTES.REGISTER} className="play-btn">
                    CLAIM STARTER CREDITS
                  </Link>
                  <a href="#chambers" className="play-btn alt">OPEN THE WINGS</a>
                </div>
              </div>
            </section>

            <div className="disclaimer-banner" role="note" aria-label="Notice">
              <h2><span className="badge">VIRTUAL-ONLY NOTICE</span></h2>
              <p>
                Velar Games is a social gaming experience. Credits are digital and hold no cash value,
                cannot be purchased, and cannot be withdrawn. Wins and losses are for on-site progression only.
              </p>
            </div>

            <section className="content-section" aria-label="Why players return">
              <h2>Why the doors stay open</h2>

              <div className="panel panel--marble">
                <ul className="notice-list">
                  <li>Starter Credits appear with every new arrival and refill over time.</li>
                  <li>Cooldown refills return you to full strength without payments.</li>
                  <li>Session history keeps track of your rituals and outcomes.</li>
                  <li>Leaderboards celebrate mastery, not money.</li>
                  <li>Every wing is virtual-only with no real-world value.</li>
                  <li>Play smoothly on desktop or mobile — the house follows you.</li>
                </ul>
              </div>
            </section>

            <section className="games-section" id="chambers" aria-label="Games">
              <h2>Choose a wing</h2>

              <div className="games-grid">
                <div className="game-card">
                  <h3>
                    <span className="game-icon">◆</span>
                    <span className="game-title">Predictor</span>
                  </h3>

                  <p className="game-desc">
                    Guess the lucky number and win virtual points. Pure entertainment with no financial
                    risk. </p>

                  <a href="https://Velar.site/game/predictor/" className="play-btn">
                    ENTER WING
                  </a>
                </div>
                <div className="game-card">
                  <h3>
                    <span className="game-icon">■</span>
                    <span className="game-title">Dice</span>
                  </h3>

                  <p className="game-desc">
                    Roll the dice and predict the outcome. Simple, fun, and completely social - no real
                    money involved! </p>

                  <a href="https://Velar.site/game/dice/" className="play-btn">
                    ENTER WING
                  </a>
                </div>
                <div className="game-card">
                  <h3>
                    <span className="game-icon">▲</span>
                    <span className="game-title">Spinners</span>
                  </h3>

                  <p className="game-desc">
                    Spin the reels and win virtual points in our custom slot machine game. Features multiple
                    paylines and bonus rounds! </p>

                  <a href="https://Velar.site/game/spinners/" className="play-btn">
                    ENTER WING
                  </a>
                </div>
                <div className="game-card">
                  <h3>
                    <span className="game-icon">⬤</span>
                    <span className="game-title">Card Game</span>
                  </h3>

                  <p className="game-desc">
                    Test your card skills against the house in this classic game. All winnings are virtual
                    points only. </p>

                  <a href="https://Velar.site/game/card-game/" className="play-btn">
                    ENTER WING
                  </a>
                </div>
              </div>
            </section>

            <section className="content-section" aria-label="About">
              <h2>How the ritual works</h2>

              <div className="panel panel--marble">
                <p style={{ margin: 0 }}>
                  Choose a wing, place your Credits, reveal the outcome, and watch your ledger update in real
                  time.
                  The house records each session, so your story stays intact from night to night.
                </p>
                <p style={{ margin: '.85rem 0 0' }}>
                  Starter Credits renew with time, and no payments are ever required. There are no deposits,
                  no withdrawals, and no real-world prizes — only the thrill of the halls.
                </p>
              </div>
            </section>

            <section className="content-section" aria-label="FAQ">
              <h2>Quick questions by candlelight</h2>
              <div className="faq-wrap">
                <div className="faq-item">
                  <h3>Is this real-money gambling?</h3>
                  <p>No. This is social entertainment with virtual Credits only.</p>
                </div>

                <div className="faq-item">
                  <h3>Can I buy or cash out Credits?</h3>
                  <p>Never. Credits can’t be purchased or withdrawn and have no cash value.</p>
                </div>

                <div className="faq-item">
                  <h3>How does a session play out?</h3>
                  <p>Select a wing, place your Credits, reveal the result, and log the outcome.</p>
                </div>

                <div className="faq-item">
                  <h3>What are Credits?</h3>
                  <p>They’re a virtual counter used only inside the mansion for tracking progress.</p>
                </div>
              </div>
            </section>

            <section className="content-section" aria-label="Contact">
              <h2>Send a signal through the halls</h2>
              <p className="section-lead">
                Report a bug, share feedback, or propose a collaboration. We’re listening at the edge of the
                lantern glow 🕸️.
              </p>

              <form id="contact-form" className="contact-form">
                <div className="form-group">
                  <label htmlFor="contact-name">NAME</label>
                  <input type="text" id="contact-name" name="name" required placeholder="Your calling name" />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-email">EMAIL</label>
                  <input type="email" id="contact-email" name="email" required placeholder="you@example.com" />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-message">MESSAGE</label>
                  <textarea id="contact-message" name="message" rows="5" required
                    placeholder="Tell us what the mansion whispered..."></textarea>
                </div>

                <button type="submit" className="submit-btn">SEND SIGNAL</button>
              </form>
            </section>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;


